export const DEVICE_OPTIONS = [
  { value: 'tablet', label: 'Планшет' },
  { value: 'panel', label: 'Пульт' },
  { value: 'router', label: 'Маршрутизатор' },
];
